import * as originalAxios from "axios";
import { ENV_RENDER_DESIGNER } from '@utils/constants'

let $originalAxios = originalAxios;
if (!$originalAxios.create) {
  $originalAxios = originalAxios.default;
}
const axios = $originalAxios.create();
export const request = async (axiosOptions, qtmOptions = {}) => {
  const {
    proxy = true,
    spin = true,
    rawResponse = true,
    handleErrCode = false
  } = qtmOptions;
  const { url } = axiosOptions;

  if (proxy !== false && !/^http/.test(url)) {
    axiosOptions.url = `/iuap-yonbuilder-mobilenode/runtime-mobile/qtmProxy/${url.replace(
      /^\//,
      ""
    )}`;
  }

  // let cancelLoading = () => {}
  let res;
  if (spin) {
  //   cancelLoading = loading()
  }
  try {
    res = await axios.request(axiosOptions);
    if (handleErrCode) {
      if (res?.data?.code !== 200) {
        // utils.err(res?.data.message || "操作失败");
      }
    }
  } catch (error) {
  } finally {
    // cancelLoading()
    // console.log("rawResponse---", rawResponse, res);
  }
  return rawResponse ? res : res.data;
};

export { axios };

export const chooseLocale = () => {
  return window?.navigator?.language || "zh";
};

// 加载文件服务js
export const loadJS = (src, id, callback, flag = () => true) => {
  const exist = document.querySelector(`#${id}`);
  if (exist && flag?.()) {
    callback?.();
    return;
  }
  // 动态创建script标签，并挂到body上
  const body = document.querySelector("body");
  const script = document.createElement("script");
  script.id = id;
  script.src = src;
  body?.appendChild(script);
  // 第一个加载完毕后
  script.onload = () => {
    const timer = setInterval(() => {
      // 条件判断成功后才可以执行回调
      if (flag?.()) {
        clearInterval(timer);
        callback?.();
      }
    }, 100);
  };
};

export const mergeMeta2Props = (props, meta, filterKeys) => {
  const newProps = { ...props, ...meta };
  if (!filterKeys) return newProps;
  const filterPropsWeb = {};
  filterKeys.forEach((key) => (filterPropsWeb[key] = newProps[key]));
  return filterPropsWeb;
};

const fn = () => { console.log('当前不是mdf6.0') }
export const ybTools = window.ybTools || { registerApis: fn, Filter: {} }

export const isDesign = (props) => {
  const { renderEnv } = props
  try {
    return renderEnv === ENV_RENDER_DESIGNER;
  } catch (e) {
    console.log(e)
    return false
  }
}

export const isJDiwork = () => {
  return window.jDiwork && window.parent.name === '_WORKBENCH_';
}

export const getFileUrl = () => {
  const baseUrl = window.location.origin + '/iuap-apcom-file'
  const resourceUrl = '/ucf-wh/fileservice/web/fileservice-web.min.js'

  return baseUrl + resourceUrl
}

export function isEmptyObject (e) {
  let t;
  for (t in e) {
    return !1;
  }
  return !0
}

export function parseCStyle (cStyle, throwOnError = false) {
  if (isEmptyObject(cStyle)) return {}
  if (typeof cStyle !== 'string') {
    return cStyle || {}
  }
  let result = {}
  try {
    result = JSON.parse(cStyle)
  } catch (error) {
    // 后端经常配错换行符，少一个反斜杠，这里统一处理一下
    cStyle = cStyle.replace(/\n/g, '\\n').replace(/\r/g, '\\r')
    try {
      result = JSON.parse(cStyle)
    } catch (error) {
      console.error('cStyle解析错误: ', error)
      console.error(cStyle)
      if (throwOnError) {
        throw error
      }
    }
  }
  return result
}

export const parseObj = (param) => {
  return !param ? undefined : (typeof param === 'string' ? JSON.parse(param) : param)
}

export const isJSON = (str) => {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str);
      if (typeof obj === 'object' && obj) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }
}

export const getJsonObj = (str) => {
  if (typeof str !== 'string') {
    return {}
  }
  let obj = {}
  try {
    obj = JSON.parse(str)
  } catch {
    obj = {}
  }
  return obj
}

// 数组去重
export const removeRepeat = (arr, key) => {
  const result = [];
  const obj = {};
  for (const x of arr) {
    if (!obj[x[key]]) {
      obj[x[key]] = x;
      result.push(x);
    }
  }
  return result;
}

export const extend = function () {
  let options; let name; let src; let copy; let copyIsArray; let clone;
  let target = arguments[0];
  let i = 1;
  const length = arguments.length;
  let deep = false;

  // Handle a deep copy situation
  if (typeof target === 'boolean') {
    deep = target;
    target = arguments[1] || {};
    // skip the boolean and the target
    i = 2;
  } else if ((typeof target !== 'object' && typeof target !== 'function') || target == null) {
    target = {};
  }

  for (; i < length; ++i) {
    options = arguments[i];
    // Only deal with non-null/undefined values
    if (options != null) {
      // Extend the base object
      for (name in options) {
        src = target[name];
        copy = options[name];

        // Prevent never-ending loop
        if (target !== copy) {
          // Recurse if we're merging plain objects or arrays
          if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
            if (copyIsArray) {
              copyIsArray = false;
              clone = src && isArray(src) ? src : [];
            } else {
              clone = src && isPlainObject(src) ? src : {};
            }

            // Never move original objects, clone them
            target[name] = extend(deep, clone, copy);

            // Don't bring in undefined values
          } else if (typeof copy !== 'undefined') {
            target[name] = copy;
          }
        }
      }
    }
  }

  // Return the modified object
  return target;
};

export const isArray = (arr) => {
  if (typeof Array.isArray === 'function') {
    return Array.isArray(arr);
  }
  return Object.prototype.toString.call(arr) === '[object Array]';
};

export const isPlainObject = (obj) => {
  if (!obj || Object.prototype.toString.call(obj) !== '[object Object]') {
    return false;
  }

  const hasOwnConstructor = Object.prototype.hasOwnProperty.call(obj, 'constructor');
  const hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && Object.prototype.hasOwnProperty.call(obj.constructor.prototype, 'isPrototypeOf');
  // Not own constructor property must be Object
  if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
    return false;
  }

  // Own properties are enumerated firstly, so to speed up,
  // if last one is own, then all properties are own.
  let key;
  for (key in obj) { /**/ }

  return typeof key === 'undefined' || Object.prototype.hasOwnProperty.call(obj, key);
};

export const flatArr = (arr, keyfield) => {
  if (!Array.isArray(arr)) return []
  return arr.reduce((acc, item) => {
    acc.push(item);
    if (Array.isArray(item[keyfield]) && item[keyfield].length > 0) {
      acc = acc.concat(flatArr(item[keyfield], keyfield));
      delete item[keyfield]; // 如果不需要保留原始结构中的 children 属性，可以选择删除它
    }
    return acc;
  }, []);

};